export const SCALING_FACTOR = 8;
